import { selectCurrencySymbol, selectLocale, selectUrlParams } from '@buy-viasat/redux/src/app';
import { selectCartDomain } from '@buy-viasat/redux/src/cart';
import { Icon, Surface, Txt } from '@vst/beam';
import { Offer } from '@vst/beam-icons/icons';
import { SkeletonLoader } from '../../SkeletonLoader';
import { useSelector } from 'react-redux';
import { priceDecimalFormat } from '@buy-viasat/utils';
import { CartProduct } from '@buy-viasat/types/build/bv';

import styles from './checkoutCartClosingOffers.module.scss';

type CheckoutCartClosingOffersProps = {
  shouldDisplayClosingOffer: boolean;
  shouldDisplayThirdMonthFreeService: boolean;
  isBackgroundAPICallLoading: boolean;
};

export const CheckoutCartClosingOffers = ({
  shouldDisplayClosingOffer,
  shouldDisplayThirdMonthFreeService,
  isBackgroundAPICallLoading,
}: CheckoutCartClosingOffersProps) => {
  const { offerId: closingOfferIdURLParam } = useSelector(selectUrlParams);
  const cart = useSelector(selectCartDomain);

  const checkForExistingClosingOffers = cart.cartItems?.closingOffers?.find(
    (closingOffer) => closingOffer?.productTypeId === closingOfferIdURLParam,
  );

  const locale = useSelector(selectLocale);
  const currencySymbol = useSelector(selectCurrencySymbol);

  if (!checkForExistingClosingOffers) {
    return null;
  }

  const { price } = checkForExistingClosingOffers;

  if (price === undefined || price === null) {
    return null;
  }

  const closingOfferPlanPrice = priceDecimalFormat(price, locale, currencySymbol);

  return (
    <Surface variant={'secondary'} data-testid={'closingOffer'}>
      <div className={styles['closingOfferContainer']}>
        {closingOfferIdURLParam && isBackgroundAPICallLoading ? (
          <>
            <SkeletonLoader characters={15} height={'sm'} />
            <SkeletonLoader characters={5} height={'sm'} />
          </>
        ) : (
          <>
            {displayOffer(
              shouldDisplayClosingOffer,
              shouldDisplayThirdMonthFreeService,
              closingOfferPlanPrice,
              checkForExistingClosingOffers,
            )}
          </>
        )}
      </div>
    </Surface>
  );
};

function displayOffer(
  shouldDisplayClosingOffer: boolean,
  shouldDisplayThirdMonthFreeService: boolean,
  closingOfferPlanPrice: string,
  checkForExistingClosingOffers: CartProduct,
) {
  if (shouldDisplayClosingOffer) {
    return (
      <>
        <Txt color="success" variant="bodySmallBold" className={styles['offerAndTag']}>
          {checkForExistingClosingOffers.name}
          <Icon icon={Offer} size="16px" color="green_700" ml="8px" />
        </Txt>

        <Txt color="success" variant="bodySmallBold">
          {`${closingOfferPlanPrice} `}
        </Txt>
      </>
    );
  }

  if (shouldDisplayThirdMonthFreeService) {
    return (
      <Txt color="success" variant="bodySmallBold" className={styles['offerAndTag']}>
        {checkForExistingClosingOffers.name}
        <Icon icon={Offer} size="16px" color="green_700" ml="8px" />
      </Txt>
    );
  }

  return null;
}
